import * as APIBase from './APIBase';
import environment from '../../environment';

const { caGetDetails, caGetDetailsQuery } = environment;

class PoiAPI {
  // static get = () => APIBase.getAPI('/getdetails?place_id=ChIJw7LpEq48TIYReeTO8cn425U');

  // static get = () => APIBase.getAPI(`/getdetails?place_id=${this.props.place_id}`);

  static get = () => APIBase.getAPI(caGetDetails);

  static getByPlaceId = placeId => APIBase.getAPI(`${caGetDetailsQuery}=${placeId}`);
}

export default PoiAPI;
